import type { OwnOrganizationDTO } from '@/dto/organizations/OwnOrganization.dto';
import { makeBinded } from '@/proxies';
import type { Some } from '@/types/Some';
import type { ValueOf } from 'type-fest';

export const ORG_TYPE = {
  AMMINISTRATORE: 'A',
  REAL_ESTATE: 'R',
  PROPERTY_MANAGER: 'P',
  SERVICE_COMPANY: 'S',
  COMPANY: 'C',
} as const;

export type OrgType = ValueOf<typeof ORG_TYPE>;

const keyLabels: Some<OwnOrganizationDTO, string> = {
  name1: 'Ragione Sociale',
  name2: 'Ragione Sociale (estensione)',
  vat: 'Partita IVA',
  nin: 'Codice fiscale',
  codeEInvoice: 'Codice Univoco',
  emailEInvoice: 'PEC',
  email: 'Email aziendale',
  landline: 'Telefono aziendale',
  mobile: 'Telefono mobile',
};

class OwnOrganizationMetaVO {
  keyLabel(key: keyof OwnOrganizationDTO) {
    return keyLabels[key] || key;
  }

  orgTypeLabel(type: OrgType, prefix?: 'determinate' | 'indeterminate' | 'directionPreposition') {
    switch (type) {
      case ORG_TYPE.AMMINISTRATORE: {
        switch (prefix) {
          case 'determinate':
            return 'l\'amministratore di condominio';
          case 'indeterminate':
            return 'un amministratore di condominio';
          case 'directionPreposition':
            return 'all\'amministratore di condominio';
          default:
            return 'amministratore di condominio';
        }
      }

      case ORG_TYPE.REAL_ESTATE:
        switch (prefix) {
          case 'determinate':
            return 'il real estate';
          case 'indeterminate':
            return 'un real estate';
          case 'directionPreposition':
            return 'al real estate';
          default:
            return 'real estate';
        }

      case ORG_TYPE.PROPERTY_MANAGER:
        switch (prefix) {
          case 'determinate':
            return 'il property manager';
          case 'indeterminate':
            return 'un property manager';
          case 'directionPreposition':
            return 'al property manager';
          default:
            return 'property manager';
        }

      case ORG_TYPE.SERVICE_COMPANY:
        switch (prefix) {
          case 'determinate':
            return 'la società che offre servizio al cittadino';
          case 'indeterminate':
            return 'una società che offre servizio al cittadino';
          case 'directionPreposition':
            return 'alla società che offre servizio al cittadino';
          default:
            return 'società che offre servizio al cittadino';
        }

      case ORG_TYPE.COMPANY:
        switch (prefix) {
          case 'determinate':
            return 'l\'azienda';
          case 'indeterminate':
            return 'un\'azienda';
          case 'directionPreposition':
            return 'all\'azienda';
          default:
            return 'azienda';
        }
    }
  }
}

const ownOrganizationMetaVO = makeBinded(OwnOrganizationMetaVO);

export { ownOrganizationMetaVO };
